import { render, staticRenderFns } from "./ServerPassword.vue?vue&type=template&id=4c70aaa8&"
import script from "./ServerPassword.vue?vue&type=script&lang=js&"
export * from "./ServerPassword.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4c70aaa8')) {
      api.createRecord('4c70aaa8', component.options)
    } else {
      api.reload('4c70aaa8', component.options)
    }
    module.hot.accept("./ServerPassword.vue?vue&type=template&id=4c70aaa8&", function () {
      api.rerender('4c70aaa8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Services/Hosting/Common/ServerPassword.vue"
export default component.exports